import React from 'react'
import PropTypes from 'prop-types'
import { NumericFormat } from 'react-number-format'

const HHDisplayPercentage = ({ value = '', ...rest }) => (
  <NumericFormat value={value} displayType="text" suffix="%" thousandSeparator {...rest} />
)

HHDisplayPercentage.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default HHDisplayPercentage
